export function getPublicAssetUrl(value) {
  if (!value) return '';
  if (typeof window === 'undefined') return value;

  if (/^https?:\/\//i.test(value)) {
    try {
      const url = new URL(value);
      const isLocalViteAsset = ['localhost', '127.0.0.1'].includes(url.hostname) && url.port === '3000' && url.pathname.startsWith('/email-signature-banners/');

      if (isLocalViteAsset) return `${url.protocol}//${url.hostname}:8080${url.pathname}`;
    } catch (error) {
      return value;
    }

    return value;
  }

  const normalizedPath = String(value).startsWith('/') ? value : `/${value}`;
  const origin = window.location.origin;
  const isLocalVite = ['localhost', '127.0.0.1'].includes(window.location.hostname) && window.location.port === '3000';

  if (isLocalVite) return `${window.location.protocol}//${window.location.hostname}:8080${normalizedPath}`;

  return `${origin}${normalizedPath}`;
}
